<template>
  <div id="app">
    <AppHeader></AppHeader>
    <router-view/>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppFooter from "./components/Footer";
import AppHeader from "./components/Header";

export default {
  components:{
    AppFooter,
    AppHeader
  },
  name: 'App',
  methods:{

  }
}
</script>

<style lang="scss">
@import "./assets/css/base/_fonts";
@import "./assets/css/index";

</style>



// WEBPACK FOOTER //
// src/App.vue